import jwtDecode from 'jwt-decode';
import {
  getStorage,
} from './localstorage';
import {
  ROLES,
} from '../constants';

export const decodeJwt = (data) => {
  const decoded = jwtDecode(data);
  // console.log("🚀 ~ decodeJwt ~ decoded:", decoded)
  return decoded;
};

const getRole = () => {
  const token = getStorage('token') || '';
  const decodeToken = token ? decodeJwt(token) : '';
  const {
    ROLE,
  } = decodeToken;
  return ROLE;
};

export const checkAccessRights = (accessibleRole) => {
  const currentRole = getRole();
  if (
    accessibleRole === ROLES.USER_ROLE ||
    accessibleRole === ROLES.ADMIN_ROLE ||
    accessibleRole === ROLES.SUPER_ADMIN_ROLE ||
    accessibleRole === ROLES.SALE_ROLE // <-- เพิ่มบรรทัดนี้
  ) {
    if (currentRole === accessibleRole) {
      return true;
    }
    return false;
  }

  return false;
};

export default checkAccessRights;
